export default __webpack_public_path__ + "static/media/multi_mortgage_logo.81ea769e.png";